var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{staticClass:"bg-vb-secondary form-control text-light _rpd-input-form",attrs:{"placeholder":_vm.placeHolder,"type":_vm.inputType},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }